<template>
  <span
    class="fehler-melden"
    @click.stop="toggleSaved()"
    @click="show = !show"
  >
    <v-dialog
      v-model="dialog"
      
      max-width="500px"
    >
      <v-btn
        slot="activator"
        color="success"
      >
        <v-icon left>event_available</v-icon>Termin hinzufügen
      </v-btn>
      <v-card>
        <v-card-text class="pt-2">
         
          <v-form
            ref="form"
            v-model="valid"
            lazy-validation
          >
            <v-container grid-list-md class="pa-0">
              <v-layout wrap row>
                <v-flex xs12>
                  <v-text-field
                    v-model="titel"
                    class="headline"
                    height="35"
                    label="Titel der Veranstaltung"
                    prepend-icon="title"
                    :rules="TitelRules">
                  </v-text-field>
                </v-flex>

                <v-flex xs12>
                  <v-menu
                    ref="menu"
                    v-model="menu"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    :return-value.sync="date => new Date(date).toDateString()"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="date"
                        label="Datum auswählen"
                        prepend-icon="event"
                        readonly
                        v-on="on"
                        :rules="DateRules"
                      ></v-text-field>
                    </template>
                    <v-date-picker 
                      v-model="date" 
                      locale="de-de" 
                      :first-day-of-week="1" 
                      scrollable
                    >
                      <v-spacer></v-spacer>
                      <v-btn flat color="primary" @click="menu = false">Abbrechen</v-btn>
                      <v-btn flat color="primary" @click="$refs.menu.save(date)">OK</v-btn>
                    </v-date-picker>
                  </v-menu>
                </v-flex>
                <v-flex xs12>
                  <v-text-field
                    v-model="ort"
                    label="Ort der Veranstaltung"
                    prepend-icon="location_on"
                  ></v-text-field>
                </v-flex>
                 <v-flex xs12>
                  <v-textarea
                    v-model="text"
                    label="Info Text"
                    prepend-icon="info"
                    auto-grow
                  ></v-textarea>
                </v-flex>
                <v-flex xs12>
                  <v-text-field
                    v-model="email"
                    label="Kontaktdaten für Nachfragen (optional)"
                    prepend-icon="email"
                  ></v-text-field>
                </v-flex>
                 <v-flex xs12>
                  <v-text-field
                    v-model="url"
                    label="Link zur Website der Veranstaltung (optional)"
                    counter
                    prepend-icon="link"
                  ></v-text-field>
                </v-flex>
                  <v-flex xs12>
                  <v-checkbox
                    v-model="versteckt"
                    label="Termin nur angemeldeten Betrieben zeigen"
                   
                  ></v-checkbox>
                </v-flex>
                 <v-flex xs12>
                  <v-select
                    label="Zugehörigen Kalender auswählen"
                    prepend-icon="calendar_today"
                    :items="this.kalender"
                    item-text="name"
                    item-value="id"
                    v-model="selectedkalender"
                    :rules="KalenderRules"
                  ></v-select>
                </v-flex>
              </v-layout>
             
            </v-container>
          </v-form>
        
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color=""
            flat
            @click.native="dialog = false"
          >Abbrechen</v-btn>
          <v-btn
            color=""
            flat
            @click.native="leerefelder()"
          >Felder leeren</v-btn>
          <v-btn
            color="primary"
            @click="terminhinzufuegen()"
            :loading="loading"
          >Termin hinzufügen</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </span>
</template>

<script>
import axios from 'axios'

export default {
  props: ['kalender'],
  data () {
    return {
      show: false,
      dialog: false,
      titel: '',
      block: false,
      loading: false,
      formatted: '',
      email: '',
      url: '',
      ort: '',
      versteckt: false,
      text: '',
      selectedkalender: null,
      valid: false,
      date: new Date().toISOString().substr(0, 10),
      menu: false,
      picker: new Date().toISOString().substr(0, 10),
      landscape: false,
      reactive: false,
      FehlertextRules: [
        v => !!v || 'Bitte Fehler angeben',
        v =>
          (v && v.length <= 500) ||
          'Bitte nicht mehr als 300 Buchstaben verwenden.'
      ],
      TitelRules: [
        v => !!v || 'Bitte Titel angeben'
      ],
      DateRules: [
        v => !!v || 'Bitte Datum angeben'
      ],
      OrtRules: [
        v => !!v || 'Bitte Ort angeben'
      ],
      TextRules: [
        v => !!v || 'Bitte Infotext angeben'
      ],
      KalenderRules: [
        v => !!v || 'Bitte Kalender auswählen'
      ]
    }
  },
  methods: {
    terminhinzufuegen () {
      if (this.$refs.form.validate()) {
        this.loading = true

        const daten = {
          id: this.id,
          text: this.text,
          titel: this.titel,
          ort: this.ort,
          date: this.date,
          kontakt: this.email,
          url: this.url,
          versteckt: this.versteckt,
          kalender: this.selectedkalender
        }

        const app = this

        axios
          .post('/api/v1/kalender', daten)
          .then(resp => {
            // console.log(resp)
            this.$store.dispatch('responseMessage', {
              type: 'success',
              title: 'Termin eingetragen',
              text: 'Termin eingetragen!'
            })
            app.$emit('kalenderrefresh')
            this.dialog = false
            // this.block = true
          })
          .catch(resp => {
            // console.log('error: ')
            // console.log(resp);
            this.$store.dispatch('responseMessage', {
              type: 'error',
              title: 'Fehler',
              text: 'Nicht eingetragen, keine Rechte für den ausgewählten Kalender'
            })
          })

        this.loading = false
      }
    },
    leerefelder () {
      this.titel = ''
      this.text = ''
      this.ort = ''
      this.email = ''
      this.url = ''
      this.date = ''
    }
  },
  computed: {}
}
</script>
<style>
</style>